import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from "@reduxjs/toolkit/query/react";

const baseUrl = `${baseURL}/exchange-rates/`;

export const exchangeRateApiService = createApi({
  reducerPath: "exchangeRateApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().authSlice.token;
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getLatestExchangeRate: builder.query({
      query: () => "current",
      keepUnusedDataFor: 0,
    }),
    getAllExchangeRates: builder.query({
      query: () => "", // Assuming the endpoint for all exchange rates is the base URL
      keepUnusedDataFor: 0,
    }),
  }),
});
export const {
  useGetLatestExchangeRateQuery,
  useGetAllExchangeRatesQuery,
} = exchangeRateApiService;
